import React from 'react';
import PropTypes from 'prop-types';

const Tooltip = ({ title, message, onClose }) => (
  <div className='tooltip'>
    <div className='tooltip__message'>
      {title && <span className='tooltip__title'>{title}</span>}
      {message && <span>{message}</span>}
    </div>
    {onClose && (
      <button
        type='button'
        className='tooltip__dismiss'
        onClick={() => onClose()}
      >
        ×
      </button>
    )}
  </div>
);

Tooltip.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func
};

export default Tooltip;
